<ng-container *ngIf="display$ | async">

  <ng-container *ngIf="viewModel$ | async as vm">
    <app-dataset-card (click)="selectWind(vm.module)"
      [selected]="sidebarRoomService.isSelected(vm.card, vm.module, GraphType.WIND)"
      [backgroundColor]="'var(--blue-10)'"
      [hoverBackgroundColor]="'var(--blue-5)'">
      <app-dataset-card-label>{{ 'common-app.__WIND' | LANG }}</app-dataset-card-label>
      <section class="is-flex gap-16">
        <div class="is-flex is-direction-column gap-4">
          <app-text class="text-12 is-family-medium">{{ 'station-app.__ACC_DASHBOARD_WIND_CURRENT' | AsyncLang | async }}</app-text>
          <div>
            <app-dataset-card-value class="text-blue">{{ vm.module.WindStrength | toUserUnit : EnumMeasureTypes.WIND_STRENGTH | toDisplayValue : EnumMeasureTypes.WIND_STRENGTH }}</app-dataset-card-value>
            <app-dataset-card-unit>
              <app-text unit [measureType]="EnumMeasureTypes.WIND_STRENGTH"></app-text>
            </app-dataset-card-unit>
          </div>
        </div>
        <div class="is-flex is-direction-column gap-4">
          <app-text class="text-12 is-family-medium">{{ 'station-app.__GUST_SPEED' | AsyncLang | async }}</app-text>
          <div>
            <app-dataset-card-value class="text-blue">{{ vm.module.GustStrength | toUserUnit : EnumMeasureTypes.GUST_STRENGTH | toDisplayValue : EnumMeasureTypes.GUST_STRENGTH }}</app-dataset-card-value>
            <app-dataset-card-unit>
              <app-text unit [measureType]="EnumMeasureTypes.GUST_STRENGTH"></app-text>
            </app-dataset-card-unit>
          </div>
        </div>
      </section>
      <app-dataset-card-preview [module]="vm.module" [measureType]="EnumMeasureTypes.WIND_STRENGTH"></app-dataset-card-preview>
    </app-dataset-card>
  </ng-container>

</ng-container>
